import React   from 'react';

import { queryClient } from '../../state/queryClient';
import { useNotifs } from '../../state/reactquery';
import {useUser} from '../../state/reactquery';

import {formatdatenotif } from '../../utils/utils_dates'
import { searchandinitialiseclient } from '../../utils/actions_lead';

import ButtonSimple from '../Buttons/ButtonSimple';
import { axios_notifs_deletenotif , axios_notifs_vidernotifs , axios_notifs_updatenotif} from '../../axios/axios_notifs';




import './Notifs.scss';

const classNames = require('classnames');

const divnotif = (notif)=>{

    const  openedtotrue = async (e)=>{if([...e.target.classList].includes('delnotif')){return }
                                        searchandinitialiseclient(notif?.id_lead, false) ;
                                        const newnotif = {...notif, 'opened':1} ;  
                                        await axios_notifs_updatenotif(newnotif) ; 
                                        const othersnotifs = queryClient.getQueryData(['notifs']).filter(x=>x.id!==notif.id)  ; 
                                        queryClient.setQueryData(['notifs'],[...othersnotifs,newnotif]); 
                        }
   
    const notifdelete = ()=>{axios_notifs_deletenotif(notif.id);
                             const othersnotifs = queryClient.getQueryData(['notifs']).filter(x=>x.id!==notif.id)  ; 
                              queryClient.setQueryData(['notifs'],[...othersnotifs]);}

    return( <div key={notif.id} id={notif.id} onClick={openedtotrue} className={classNames('notif','notif_'+notif.type_notif,{'notif_noopened': notif.opened ===0  })}   >
                    <div className='delnotif'   onClick={notifdelete}  ></div>
                    <div className='notif_date' >{formatdatenotif(notif?.date_notif ?? new Date())} </div>
                    <div className='notif_texte'   dangerouslySetInnerHTML={{__html: notif?.notification}} />     
            </div>)
}
 

function Notifs(){
    const {data : notifs} = useNotifs();
    const {data: user} = useUser(localStorage.getItem('token'))  ;

    const vidernotifs = async()=>{await axios_notifs_vidernotifs(user.postmail) ;
                                  queryClient.invalidateQueries({ queryKey: ['notifs']})
    }

    return(<div   id='notifs' className='notifs' >
               <div className='notifs_top' > Notifications  <span>{notifs?.length} </span>    </div>
               <div className='notifs_middle' >
                       {notifs?.length>0 && notifs.sort((b,a)=> new Date(a?.date_notif) - new Date(b?.date_notif)  ).map(notif=>divnotif(notif) )  }
                 </div>
                <div className='notifs_bottom' >
                        <ButtonSimple  texte="Vider"   color='bouton_color_grisblanc' size='bouton_size_normal' disable={false} onclick={vidernotifs}   />  
                </div>
           </div>);
}


export default Notifs